import { render, staticRenderFns } from "./ParkManage.vue?vue&type=template&id=513f7f52&scoped=true&"
import script from "./ParkManage.vue?vue&type=script&lang=js&"
export * from "./ParkManage.vue?vue&type=script&lang=js&"
import style0 from "./ParkManage.vue?vue&type=style&index=0&id=513f7f52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f7f52",
  null
  
)

export default component.exports